import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import PanelPage from 'navigation/pages/PanelPage';
import store from 'store';
export default class ReturnsItemSelectSize extends PanelPage {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            quickbuyForm: ['.form.returnsSelectSizeHeader_form', Form]
        };
    }
    resize() {
        super.resize();
        this.el.style.setProperty('--size-header-height', `${this.refs.returnsSelectSizeHeader.offsetHeight}px`);
        this.el.style.setProperty('--size-confirm-height', `${this.refs.returnsSelectSizeConfirm.offsetHeight}px`);
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        this.refs.selectSize[method]('click', this.onSelectSize);
    }
    onSelectSize = async (e) => {
        const valid = await this.modules.quickbuyForm.quickValid();
        if (!valid)
            return;
        const waiter = [];
        await Promise.all(waiter);
        const { article } = this.modules.quickbuyForm.getFormValues();
        const label = this.modules.quickbuyForm.el.querySelector(`[for="${article}"]`);
        window.dispatchEvent(new CustomEvent('returns:update-size', {
            detail: {
                id: this.el.dataset.id,
                sizeId: article,
                sizeName: label.innerText
            }
        }));
        store.panel.set(null);
    };
}
